tinymce.PluginManager.add('expansion', function (editor, url) {
    editor.ui.registry.addIcon(
        "expansion-icon",
        `<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="design-iconfont">
  <mask id="tfni9g7pp__j2r6aufxza" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" rx="4.66667" transform="matrix(0 -1 -1 0 24 24)" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#tfni9g7pp__j2r6aufxza)" fill-rule="evenodd" clip-rule="evenodd">
    <path d="M6.15681 4.99774C6.5213 4.63325 7.11225 4.63325 7.47674 4.99774L21.006 18.527C21.3705 18.8915 21.3705 19.4825 21.006 19.847L19.8511 21.0019C19.4866 21.3664 18.8957 21.3664 18.5312 21.0019L8.67217 11.1429L11.1463 8.66876L9.9089 7.43132L7.43474 9.90548L5.00187 7.47261C4.63738 7.10812 4.63738 6.51717 5.00187 6.15268L6.15681 4.99774Z" fill="url(#tfni9g7pp__paint0_linear_146_6709)"/>
    <path d="M17.1153 10.3051C16.3262 9.49033 16.3274 8.19431 17.1187 7.38087C16.3067 8.17048 15.0142 8.173 14.1992 7.38842C14.9834 8.20253 14.9819 9.49357 14.1946 10.3058C15.0081 9.51777 16.3015 9.51754 17.1153 10.3051Z" fill="url(#tfni9g7pp__paint1_linear_146_6709)"/>
    <path d="M12.3784 4.67728C11.3762 3.65784 11.3747 2.02315 12.374 1.0019C11.3473 2.00632 9.70074 1.99943 8.68255 0.981238L8.68252 0.98121L8.68218 0.981558C9.70676 2.00659 9.70675 3.66806 8.68214 4.69308L8.68261 4.69355C9.70227 3.67396 11.352 3.66853 12.3784 4.67728Z" fill="url(#tfni9g7pp__paint2_linear_146_6709)"/>
    <path d="M6.24614 15.1872C5.44781 14.3702 5.44923 13.0634 6.2504 12.2482C5.42927 13.0549 4.10966 13.0504 3.29404 12.2348L3.29401 12.2348L3.29364 12.2352C4.11334 13.0552 4.11339 14.3843 3.29378 15.2044L3.29407 15.2046C4.1083 14.3905 5.42474 14.3847 6.24614 15.1872Z" fill="url(#tfni9g7pp__paint3_linear_146_6709)"/>
  </g>
  <defs>
    <linearGradient id="tfni9g7pp__paint0_linear_146_6709" x1="5.57934" y1="5.57521" x2="20.4286" y2="20.4244" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FF4789"/>
      <stop offset="1" stop-color="#4790FF"/>
    </linearGradient>
    <linearGradient id="tfni9g7pp__paint1_linear_146_6709" x1="14.5" y1="7.5" x2="17.1168" y2="10.3036" gradientUnits="userSpaceOnUse">
      <stop stop-color="#C260B1"/>
      <stop offset="1" stop-color="#6F81E6"/>
    </linearGradient>
    <linearGradient id="tfni9g7pp__paint2_linear_146_6709" x1="12.3659" y1=".993817" x2="8.67436" y2="4.68535" gradientUnits="userSpaceOnUse">
      <stop stop-color="#4790FF"/>
      <stop offset=".62" stop-color="#FF4789"/>
    </linearGradient>
    <linearGradient id="tfni9g7pp__paint3_linear_146_6709" x1="3.5" y1="15" x2="6" y2="12" gradientUnits="userSpaceOnUse">
      <stop stop-color="#4790FF"/>
      <stop offset=".635" stop-color="#FE488B"/>
    </linearGradient>
  </defs>
</svg><span>扩写</span>
`
    );

    // 注册一个工具栏按钮名称
    editor.ui.registry.addButton('expansion', {
        icon: `expansion-icon`,
        tooltip: '扩写',
        onAction: function () {
            window.postMessage("openExpansion", "*");
        }
    });

    return {
        getMetadata: function () {
            return {
                //插件名和链接会显示在“帮助”→“插件”→“已安装的插件”中
                name: "",//插件名称
                url: "", //作者网址
            };
        }
    };
});